import React from "react";
import { Box, Botao, TipoBotao, Alerta, TipoAlerta } from "@intechprev/componentes-web";
import { PlanoService, RecadastramentoService } from "../../services";
import { MasterPage } from "..";
import { WebRecadParticipanteDadosEntidade } from "../../entidades";
import { Passos } from ".";

interface Props {
  DadosOriginais: WebRecadParticipanteDadosEntidade;
  Avancar: () => void;
  Voltar: () => void;
  setDadosPasso: any;
  NumeroPassoAtual: number;
}

interface State {
  PPE: string;
  CorCheckbox: string;
  checked: boolean;
}

export class Passo8 extends React.Component<Props, State> {
  private page = React.createRef<MasterPage>();
  private alerta = React.createRef<Alerta>();

  constructor(props: Props) {
    super(props);

    this.state = {
      PPE: "",
      CorCheckbox: "danger",
      checked: false
    };
  }

  componentDidMount = async () => {
    try {
      // this.page.current.loading(false);

      this.setState({
        PPE: this.props.DadosOriginais.POLIT_EXP
      });
    } catch (e) {
      const err: any = e;
      this.alerta.current.adicionarErro(err.response ? err.response.data : err);
    }
  };

  SalvarDados = () => {
    const d = {
      PPE: this.state.PPE,
    };
    this.props.setDadosPasso(Passos.Passo8, d);
  };


  Voltar = () => {
    this.SalvarDados();

    this.props.Voltar();
  };

  Proximo = () => {
    this.SalvarDados();
    this.props.Avancar();
  };

  render() {
    return (
      <Box titulo={`Passo ${this.props.NumeroPassoAtual} - Pessoa Exposta Politicamente`}>
        <Alerta tipo={TipoAlerta.info} mensagem={"Declaro para fins do atendimento às exigências da Instrução PREVIC nº 34/2020 que:"} />

        <div className="box d-flex flex-column p-3">
          <label className="d-flex align-items-center">
            <input
              name={"PolitExp"}
              className={"m-2"}
              value={"S"}
              type={"radio"}
              checked={this.state.PPE === "S"}
              onChange={(e: any) => {
                this.setState({ PPE: e.target.value });
              }}
            />
            {'ESTOU enquadrado(a) como "Pessoa Exposta Politicamente"'}
          </label>

          <label className="d-flex align-items-center">
            <input
              name={"PolitExp"}
              className={"m-2"}
              value={"N"}
              type={"radio"}
              checked={this.state.PPE !== "S"}
              onChange={(e: any) => {
                this.setState({ PPE: e.target.value });
              }}
            />
            {'NÃO ESTOU enquadrado(a) como "Pessoa Exposta Politicamente'}
          </label>
        </div>

        <Alerta
          tipo={TipoAlerta.info}
          mensagem={'Sendo "pessoa exposta politicamente" pessoa natural que desempenha ou tenha desempenhado, nos cinco anos anteriores, cargo, emprego ou função pública relevantes, assim como funções relevantes em organizações internacionais.'}
        />

        <Alerta tipo={TipoAlerta.danger} ref={this.alerta} />

        <Botao onClick={this.Voltar} titulo={"Voltar"} className={"m-2"} tipo={TipoBotao.light} icone={"angle-double-left"} iconeDireita />

        <Botao onClick={this.Proximo} titulo={"Continuar"} icone={"angle-double-right"} iconeDireita />
      </Box>
    );
  }
}
